
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaTools, FaLaptopCode, FaUsersCog } from 'react-icons/fa'; 

// Import the external CSS file
import './NossosServicos.css';
import { Link } from 'react-router-dom';

const NossosServicos = () => {
  return (
    <section className="nossos-servicos-section">
      <h2 className="nossos-servicos-title">Nossos Serviços</h2>

      <Container>
        <Row>
          {/* Coluna 1: Manutenção Predial */}
          <Col md={4} className="nossos-servicos-column">
            <div className="nossos-servicos-card">
              <h3 className="nossos-servicos-card-title">
                <FaTools className="icon-style" /> Manutenção Predial
              </h3>
              <p style={{ color: '#555' }}>
                Garantimos a funcionalidade e preservação de suas 
                instalações, eliminando riscos e prolongando a vida útil dos seus ativos, oferendo Serviços como: <br />
                 
<ul style={{textAlign:'left'}} className='services-list'>
<li> Gestão e Manutenção De ETA</li>
  <li> Implementação de sistemas de canalização</li>
  <li>Manutençã e instalação electrica de média e alta tensão</li>
 <li>Montagem de cancela</li>
<li>Reparação de cancela </li>
<li>Serviços de Jardinagem </li>
<li> Instalação e Manutenção de AVAC</li> 
 <li>Serviços de Jardinagem </li>
 <li>Alvenaria e acabamento de interior</li>
 <li>Instalação e teste de sistemas de deteção e combate a incêndios</li>
<li>Manutenção de piscinas</li>
<li>Serralharia</li> 
  </ul>
 

              </p>
               <Link to="/Manutencaopredial">
              <Button className="nossos-servicos-button">Ver Projetos</Button></Link>
            </div>

          </Col>

          {/* Coluna 2: Tecnologia de Informação */}
          <Col md={4} className="nossos-servicos-column">
            <div className="nossos-servicos-card">
              <h3 className="nossos-servicos-card-title">
                <FaLaptopCode className="icon-style" /> Tecnologia de Informação
              </h3>
              <p style={{ color: '#555' }}>
                Transformamos processos com soluções digitais sob medida, aumentando sua produtividade e competitividade, oferecendo serviços como:
                <ul className='services-list' style={{textAlign:'left'}}>
                  <li>  Segurança electronica </li>
                  <li>Sistema de video vigilancia CCTV </li>
                  <li>Sistema de monitoramento de velocidade(RADAR) </li>
                  <li>Instalação e manutenção de rede informatica e telecomunicação </li>
                  <li>Instalação de controle de acesso RFID e fechaduras magneticas</li>
                  <li> Serviços de energia Renovaveis</li>
                  <li>Instalação de software de arquitectura e desenho </li>

                </ul>
              </p>

              <Link to="/TecnologiaDeinformação">
                            <Button className="nossos-servicos-button">Ver Projetos</Button></Link>

            </div>
          </Col>

          {/* Coluna 3: Consultoria */}
          <Col md={4} className="nossos-servicos-column">
            <div className="nossos-servicos-card">
              <h3 className="nossos-servicos-card-title">
                <FaUsersCog className="icon-style" /> Consultoria
              </h3>
              <p style={{ color: '#555' }}>
                Oferecemos estratégias personalizadas para impulsionar o crescimento e a eficiência do seu negócio.Oferecemos consultoria em Serviços de Manutenção Predial e Tecnologia de Informação
              </p>
              <Button className="nossos-servicos-button">Ver Projetos</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NossosServicos;
